<template>
  <HelloWorld  v-if="!route.meta.hideLayout" />
   <router-view></router-view>
  <homeButtom v-if="!route.meta.hideLayout" />
</template>

<script setup>
import { useRoute } from 'vue-router';
import HelloWorld from '@/components/homeTopButton/homeTop.vue'
import homeButtom from '@/components/homeTopButton/homeButtom.vue'
const route = useRoute();

</script>

<style>
</style>
